'use client'

import { TechChip } from '@/components/TechChip'
import type { TechItem } from '@/lib/projectsData'
import { useAnalytics } from '@/hooks/useAnalytics'

export function TechStackSection({
  technologies,
  projectName,
}: {
  technologies: TechItem[]
  projectName: string
}) {
  const { track } = useAnalytics()

  const handleTechClick = (tech: string) => {
    track('tech_stack_interest', {
      technology: tech,
      project: projectName,
      location: 'project_detail',
    })
  }

  return (
    <div className="mt-4 flex flex-wrap gap-3">
      {technologies.map((tech) => (
        <TechChip
          key={tech.name}
          className="flex cursor-pointer items-center rounded-full bg-zinc-100 px-3 py-1.5 text-sm font-medium text-zinc-800 transition-colors hover:bg-zinc-200 dark:bg-zinc-800/80 dark:text-zinc-200 dark:hover:bg-zinc-700"
          label={tech.name}
          logoName={tech.name}
          logoSize={20}
          logoClassName="mr-2 size-5"
          onClick={() => handleTechClick(tech.name)}
        />
      ))}
    </div>
  )
}
